<template>
  <div></div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      successMessage: "Até mais ;)"
    };
  },
  created() {
    this.logOut();
  },
  methods: {
    ...mapActions(["showMessage"]),
    ...mapMutations([
      "setUserId",
      "setUserName",
      "setUserEmail",
      "setUserToken",
      "setUserIsAdmin"
    ]),
    logOut() {
      const that = this;
      that.showMessage({
        title: that.successMessage,
        css: "bg-success"
      });
      setTimeout(function() {
        that.setUserId(null);
        that.setUserName(null);
        that.setUserEmail(null);
        that.setUserToken(null);
        that.setUserIsAdmin(null);
        that.$ls.remove(process.env.VUE_APP_LOCAL_STORAGE_NAME);
        that.$router.push("/");
      }, 1000);
    }
  }
};
</script>
